/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AccessEligibilityResultModel } from "./AccessEligibilityResultModel";
import type { AccessEligibilityStatus } from "./AccessEligibilityStatus";
import type { AccessTrack } from "./AccessTrack";

/**
 * Where a track's eligibility check stands, whether or not this request started it.
 */
export interface AccessEligibilityStatusResponse {
  status: AccessEligibilityStatus;
  track: AccessTrack;
  result?: AccessEligibilityResultModel | null;
  error?: string | null;
  settled_at?: string | null;
}
